var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxesFilledDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#bab4c3ff",
    d: "M11.512 13.78a.75.75 0 0 1 .75.75v4.24l7.053-1.96v-2.755h1.5v2.932c0 .57-.38 1.07-.93 1.222l-7.28 2.022q-.322.088-.653.128a.74.74 0 0 1-.845.028 5 5 0 0 1-.657-.087l-7.71-1.623a1.27 1.27 0 0 1-1.007-1.241v-3.381h1.5v3.192l7.526 1.585h.003V14.53a.75.75 0 0 1 .75-.75m9.004-7.089a1.27 1.27 0 0 1 1.17.724l.043.1 1.212 3.236a1.27 1.27 0 0 1-.86 1.67l-6.873 1.833a1.27 1.27 0 0 1-1.365-.498l-2.332-3.33-2.331 3.33a1.27 1.27 0 0 1-1.366.498L.941 12.422a1.27 1.27 0 0 1-.86-1.671l1.213-3.236.042-.1a1.27 1.27 0 0 1 1.17-.724l.108.007 8.576.904q.171.019.32.076.15-.058.322-.076l8.576-.904z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxesFilledDark);
export default __webpack_public_path__ + "static/media/boxes_filled_dark.eeb200e89674fafd6657c697ec2ea6ea.svg";
export { ForwardRef as ReactComponent };